import {
  GET_GROUP_MEMBERS_SUCCEEDED,
  GET_DISABLED_USERS_SUCCEEDED,
  GET_GROUPS_SUCCEEDED,
  READ_USER_REQUESTED,
  READ_USER_SUCCEEDED,
  READ_USER_FAILED,
  UPDATE_USER_SUCCEEDED,
  UPDATE_USER_IMAGE_SUCCEEDED,
} from "../actions/users";

export const initialState = {
  groups: [],
  disabled: [],
  profile: {
    first_name: "",
    last_name: "",
    display_name: "",
    job_title: "",
    bio_line: "",
    email: "",
    username: "",
    photo: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUP_MEMBERS_SUCCEEDED:
      return { ...state, [action.payload.group]: action.payload.results };
    case GET_DISABLED_USERS_SUCCEEDED:
      return { ...state, disabled: action.payload.results };
    case GET_GROUPS_SUCCEEDED:
      return { ...state, groups: action.payload.results };
    case READ_USER_REQUESTED:
      return { ...state, profile: { loading: true } };
    case READ_USER_SUCCEEDED:
      return {
        ...state,
        profile: {
          ...action.payload,
          loading: false,
        },
      };
    case READ_USER_FAILED:
      return { ...state, payload: action.payload, error: true };
    case UPDATE_USER_SUCCEEDED:
    case UPDATE_USER_IMAGE_SUCCEEDED:
      return { ...state, profile: action.payload };
    default:
      return state;
  }
};
